var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('section',[_c('SectionHeader',{attrs:{"title":"Enquiry form"}}),_c('div',{staticClass:"common__section-body"},[_c('EnquiryForm',{staticClass:"enruiry-form__form-container"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }